/**
 * 当前允许选择的登录方式
 */
export const LOGIN_TYPES = {
  ALPHA: 'alphaLogin',
  WECHAT_WEB: 'wechatWebLogin',
  // 企业微信登录
  WORK_WECHAT_WEB: 'workWechatWebLogin', // 扫码登录
  WORK_WECHAT_AUTH: 'workWechatAuthLogin', // 授权登录
  // 飞书登录
  FEISHU_WEB: 'feishuWebLogin' // 飞书授权登录
}
